import type { Channel } from '@/Enums/Channel.enum';
import MetricCard from '@/components/Forecast/Estimation/MetricCard';
import { formatBidCpmGuidance } from '@/helpers/bidCpmGuidance';
import useForecasterBidCpmGuidance from '@/hooks/useForecasterBidCpmGuidance';

interface IProps {
  currentChannel?: Channel;
}

const BidCpmGuidance = ({ currentChannel }: IProps) => {
  const guidance = useForecasterBidCpmGuidance(currentChannel);

  if (!guidance) return null;

  return <MetricCard aria-label='Bid CPM Guidance' label='Bid CPM Guidance' value={formatBidCpmGuidance(guidance)} />;
};

export default BidCpmGuidance;
